import React, { useEffect, useState } from 'react'
import { StaticGoogleMap, Marker } from 'react-static-google-map'
import './GoogleMapBox.scss'
import phoneIcon from './icons/phone-icon.svg'
import hospitalIcon from './icons/hospital-icon.svg'
import emailIcon from './icons/email-icon.svg'
import openIcon from './icons/open-icon.svg'
import mapPinIcon from './icons/map-pin-icon.svg'

let bufferTimer = null
let onMapResizeThrottle

const GoogleMapBox = ({
  clinic,
  address,
  callText,
  directionText,
  websiteText,
  emailText,
  privateText,
  googleMapsApiKey,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  let paddingPercent = 6.25 * 2 // 6.25 side padding on mobile
  if (windowWidth > 525) {
    paddingPercent = 5.7 * 2
  } // 5.7 * 2 side padding for tablet
  if (windowWidth > 1024) {
    paddingPercent = 0
  } // up until we hit the max width of 640 + side padding, then we subtract no more
  const totalSidePadding = parseInt((windowWidth * paddingPercent) / 100)

  let mapWidth = Math.min(windowWidth - totalSidePadding, 640)
  if (windowWidth > 1024) {
    mapWidth = 370
  } // small sidebar for desktop

  let zoomLevel = '14'
  if (windowWidth > 400 && windowWidth < 1000) zoomLevel = '15' // slightly zoomed in for tablet

  useEffect(() => {
    onMapResizeThrottle = () => {
      if (bufferTimer) clearTimeout(bufferTimer)

      bufferTimer = setTimeout(() => {
        setWindowWidth(window.innerWidth)
      }, 500)
    }

    window.addEventListener('resize', onMapResizeThrottle, true)

    return () => {
      window.removeEventListener('resize', onMapResizeThrottle, true)
    }
  }, [])

  return (
    <div className="GoogleMapBox">
      <div className="map-container">
        <div className="static-map-container">
          <StaticGoogleMap
            size={`${mapWidth}x${parseInt(mapWidth / 2)}`}
            zoom={zoomLevel}
            className="staticmap"
            apiKey={googleMapsApiKey}
          >
            <Marker location={`${clinic.lat},${clinic.lng}`} color="red" />
          </StaticGoogleMap>
        </div>

        <div className="address-and-links">
          <h4>{clinic.formatted_name}</h4>
          {privateText && <i>{privateText}</i>}
          {address && <p>{address}</p>}

          <div className="contact-row">
            <a href={`tel:${clinic.formatted_phone}`}>
              <img src={phoneIcon} alt="phone" />
              <p>
                {callText}&nbsp;
                {clinic.formatted_phone}
              </p>
            </a>
          </div>

          {clinic.url && (
            <>
              <div className="divider" />
              <div className="contact-row">
                <a
                  href={clinic.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="clinic-link"
                >
                  <img src={hospitalIcon} alt="hospital" />
                  <p>{websiteText}</p>
                </a>
              </div>
            </>
          )}

          {clinic.general_email && (
            <>
              <div className="divider" />
              <div className="contact-row">
                <a href={`mailto:${clinic.general_email}`}>
                  <img src={emailIcon} alt="" />
                  <p className="cap-me">{emailText}</p>
                </a>
              </div>
            </>
          )}

          {address && (
            <>
              <div className="divider" />
              <div
                className={`contact-row ${
                  clinic.address_private ? 'private' : ''
                }`}
              >
                <a
                  href={`http://maps.google.com?daddr=${address}`}
                  className="google-link no-external-link-styling"
                  target="_blank"
                  rel="noopener noreferrer"
                  disabled={!!clinic.address_private}
                >
                  <img src={mapPinIcon} alt="" />
                  <p>{directionText}</p>
                  <img className="open-icon" src={openIcon} alt="open" />
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default GoogleMapBox
